export default [
  {
    path:'/admin/private/index',
    name:'PrivateIndex',
    component: () => import('@/views/private/index'),
    meta:{
      title:'总览',
      keepAlive:false
    }
  },
  {
    path:'/admin/private/station/system_update',
    name:'SystemUpdate',
    component: () => import('@/views/private/station/system_update'),
    meta:{
      title:'站点-系统更新',
      keepAlive:false
    }
  },
  {
    path:'/admin/private/station/system_log',
    name:'SystemLog',
    component: () => import('@/views/private/station/system_log'),
    meta:{
      title:'站点-系统历史更新日志',
      keepAlive:false
    }
  },
  {
    path:'/admin/private/station/storage',
    name:'Storage',
    component: () => import('@/views/private/station/storage'),
    meta:{
      title:'站点-存储配置',
      keepAlive:false
    }
  },
  {
    path:'/admin/private/station/station_setting',
    name:'StationSetting',
    component: () => import('@/views/private/station/station_setting'),
    meta:{
      title:'站点-站点设置',
      keepAlive:false
    }
  },
  {
    path: '/admin/private/role_list',
    name:'RoleList',
    component:()=>import('@/views/private/power/role_list'),
    meta: {
      title: '角色管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/employees_list',
    name:'EmployeesList',
    component:()=>import('@/views/private/power/employees_list'),
    meta: {
      title: '员工管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/employees_detail',
    name:'EmployeesEdit',
    component:()=>import('@/views/private/power/employees_detail'),
    meta: {
      title: '员工编辑',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/power_list',
    name:'PrivatePowerList',
    component:()=>import('@/views/private/power/power_list'),
    meta: {
      title: '权限管理',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/apply_list',
    name:'ApplyList',
    component:()=>import('@/views/private/apply/apply_list'),
    meta: {
      title: '我的应用',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/log_list',
    name:'LogList',
    component:()=>import('@/views/private/apply/log_list'),
    meta: {
      title: '操作日志',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/plug_list',
    name:'PlugList',
    component:()=>import('@/views/private/plug/plug_list'),
    meta: {
      title: '插件列表',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/order_list',
    name:'PrivateOrderList',
    component:()=>import('@/views/private/plug/order_list'),
    meta: {
      title: '我的订单',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/add_apply',
    name:'AddApply',
    component:()=>import('@/views/private/apply/add_apply'),
    meta: {
      title: '添加应用',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/details_list',
    name:'PlugDetails',
    component:()=>import('@/views/private/plug/details_list'),
    meta: {
      title: '插件详情',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/configure_plug',
    name:'ConfigurePlug',
    component:()=>import('@/views/private/plug/configure_plug'),
    meta: {
      title: '配置插件',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/super/config',
    name:'PrivateSuperConfig',
    component:()=>import('@/views/private/super/config'),
    meta: {
      title: '账号设置',
      keepAlive: false
    }
  },
  {
    path: '/admin/private/apply/renew',
    name:'PrivateApplyRenew',
    component:()=>import('@/views/private/apply/renew'),
    meta: {
      title: '续费应用',
      keepAlive: false
    }
  },
  {
    path: '/admin/apply/upgrade',
    name:'PrivateApplyUpgrade',
    component:()=>import('@/views/private/apply/upgrade'),
    meta: {
      title: '升级应用',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/private.js